export default {
  injuryImpact: {
    title: "Injuries",
    labels: {
      withoutPlayer: "Without {{player}}",
    },
    empty: {
      title: "No injuries available",
    },
  },
};
